import { useEffect, useState } from 'react';
// This hook detects if the user is on a mobile device or if the viewport width is less than 1400px.
export const useInMobile = () => {
  const [inMobile, setInMobile] = useState(false);
  const [in1400px, setIn1400px] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setInMobile(window.matchMedia('(max-width: 879px)').matches);
      setIn1400px(window.matchMedia('(max-width: 1400px)').matches);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    inMobile,
    in1400px,
  };
};
